import Section1 from "../pages/partner/Section1"
import "../assets/css/partner.css"
import Section3 from "../pages/homepage/Section3"
import Section4 from "../pages/partner/Section4"
import Section5 from "../pages/partner/Section5"
import Section6 from "../pages/partner/Section6"
import Section7 from "../pages/partner/Section7"
import Section8 from "../pages/partner/Section8"
import Section3DM from "../pages/products-pages/Section3DM"

const Partner = () => {
  return (
    <div className="partner-page" style={{overflow: "hidden"}}>
        <Section1 />
        <Section3 title="TRUSTED BY THE BIGGEST NAMES IN FOOD-NOW IT'S YOUR TURN." />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section3DM />
        <Section7 />
        <Section8 />
    </div>
  )
}

export default Partner